import { ROUTES } from '~~/constants/routes';

import type { UseMyAccountPage } from '~~/types/myaccount/UseMyAccountPage';

export const useMyAccount = () => {

  const { isLoyaltyDiscountEnabled } = useStoreVsfExtended();
  const myProfile = useAccountInternalPage(ROUTES.MY_PROFILE, 'My profile', 'iconify fa-pro-light--user');
  const myOrders = useAccountInternalPage(
    ROUTES.MY_ORDERS, 'My orders', 'iconify fa-pro-light--cart-shopping');
  const myNewsletter = useAccountInternalPage(
    ROUTES.MY_NEWSLETTER, 'My newsletter', 'iconify fa-pro-light--envelope');
  const myExpondoPartners = useAccountInternalPage(
    ROUTES.MY_EXPONDO_PARTNERS, 'expondo Partners', 'iconify fa-pro-light--handshake');
  const logoutPage = useLogoutPage();
  const urlList = computed<ReturnType<UseMyAccountPage>[]>(() => {

    const urls = [
      myProfile,
      myOrders,
      myNewsletter,
    ];

    if (isLoyaltyDiscountEnabled.value) {

      urls.push(myExpondoPartners);

    }

    urls.push(logoutPage);

    return urls;

  });

  return {
    urlList,
  };

};
